import React from 'react';
import { useHistory } from 'react-router-dom';

import { handleRedirection } from 'utils/utils';

export default function LeadItem({ data }) {
  const history = useHistory();
  const redirectToPage = (e, route) => {
    e.preventDefault();
    handleRedirection(history, route);
  };

  return (
    <div className="border shadow-small p-3 my-2 msg-dtls">
      <div className="my-2 text-break">
        <span className="text-medium">Practice area:</span> {data?.case_description?._case_practice_area_ || 'N/A'}
      </div>
      <div
        className="my-2 text-break"
        onClick={(e) => {
          const route = data?.case_id ? `/leads/${data?.case_id}` : '/leads';
          redirectToPage(e, route);
        }}
      >
        <span className="text-medium">Lead:</span>{' '}
        <span className="redirection-link-no-text-transform">{data?.case_description?.case_name ?? 'N/A'}</span>
      </div>
      <div className="my-2 text-break">
        <span className="fw-bold">Lead Status:</span> {data?.status ?? 'N/A'}
      </div>
    </div>
  );
}
